import type {MyAdFormCategory} from '@frontend/modules/private/ads/MyAdsModuleTypes'

// Собрать путь к категории по ID.
// Порядок: 0 => корневая ... n => категория с переданным id.
export function makeCategoryPath(
    categories: readonly MyAdFormCategory[],
    id?: number | null
): MyAdFormCategory[] {
    if (!id) {
        return []
    }
    for (const item of categories) {
        if (item.value === id) {
            return [item]
        } else if (item.extra?.children?.length) {
            const path: MyAdFormCategory[] = makeCategoryPath(
                item?.extra?.children,
                id
            )
            if (path.length) {
                return [item].concat(path)
            }
        }
    }
    return []
}
